(() => {
  const setup = async () => {
    const configNode = document.querySelector('[data-cuvp-product-config]');
    if (!configNode || configNode.dataset.ready) return;
    configNode.dataset.ready = 'true';
    const config = JSON.parse(configNode.textContent);
    const suffix = config.title.split(' Case for ');
    const stem = suffix.length > 1 ? suffix[0] : config.title.replace(/(?:Phone )?Case\s*[–—-].*$/i, '').trim();
    const tags = [...config.tags].sort((a,b) => b.length-a.length);
    const exactModel = tags.find(tag => /^(iPhone|Galaxy|Pixel|Xiaomi|Redmi|POCO|OnePlus|iPad)\b/i.test(tag) && /\d/.test(tag) && config.title.toLowerCase().includes(tag.toLowerCase()));
    const readPage = async url => {
      const requestUrl = new URL(url, location.origin);
      const themeId = window.Shopify?.theme;
      if (themeId?.role === 'unpublished') requestUrl.searchParams.set('preview_theme_id', themeId.id);
      const response = await fetch(requestUrl, {credentials:'same-origin'});
      if (!response.ok) throw new Error('Unable to load designs');
      return new DOMParser().parseFromString(await response.text(), 'text/html');
    };
    const picker = document.querySelector('[data-cuvp-model-picker]');
    picker?.addEventListener('toggle', async () => {
      if (!picker.open || picker.dataset.loaded) return;
      picker.dataset.loaded = 'true';
      const target = picker.querySelector('[data-cuvp-model-list]');
      try {
        let url = `/search?type=product&q=${encodeURIComponent(`title:"${stem.replaceAll('"','')}"`)}&view=cuvp-models`;
        const links=[];
        for(let page=0;url && page<3;page++) {
          const doc=await readPage(url);
          for(const link of doc.querySelectorAll('[data-cuvp-model-title]')) {
            const title=link.dataset.cuvpModelTitle;
            if(!title.startsWith(`${stem} Case for `) || link.dataset.handle===config.handle) continue;
            link.textContent=title.slice(`${stem} Case for `.length);
            links.push(link);
          }
          url=doc.querySelector('[data-cuvp-model-results]')?.dataset.next || '';
          if(url) {const next=new URL(url,location.origin);next.searchParams.set('view','cuvp-models');url=next.href;}
        }
        target.replaceChildren(...links);
        if(!links.length) target.textContent=config.modelError;
      } catch {target.textContent=config.modelError;picker.dataset.loaded='';}
    });
    const section=document.querySelector('[data-cuvp-exact-recommendations]');
    if(!section || !exactModel) return;
    try {
      const url=`/search?type=product&q=${encodeURIComponent(`title:"${exactModel}"`)}&view=cuvp-cases`;
      const doc=await readPage(url);
      const cards=[...doc.querySelectorAll('[data-cuvp-search-results] article')].filter(card=>card.dataset.handle!==config.handle && !card.dataset.handle.startsWith('custom-')).slice(0,4);
      if(!cards.length) return;
      section.querySelector('[data-cuvp-recommendation-grid]').replaceChildren(...cards);
      section.querySelector('[data-cuvp-recommendation-model]').textContent=exactModel;
      section.hidden=false;
    } catch {section.hidden=true;}
  };
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',setup);else setup();
  document.addEventListener('shopify:section:load',setup);
})();
